(function ($, Drupal) {
  'use strict';

  $.extend({
    getUrlVars: function () {
      var vars = [], hash;
      var url = decodeURIComponent(window.location.href);
      var hashes = url.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    getUrlVar: function (name) {
      return $.getUrlVars()[name];
    }
  });

  // global vars
  var medium = 641;
  var desktop = 1064;


  function multiSelectNavigation(e) {
    if (e.which === 40 || e.which === 38 || e.which === 32 || e.which === 13 || e.which === 9) {
      var el = $('.ms-drop:visible li:not(.ms-no-results)');
      var elActive = $('.ms-drop:visible li:not(.ms-no-results).active');
      var index = elActive.index();
      var maxLength = el.length - 1;

      // down or tab
      if (e.which === 40 || (!e.shiftKey && e.which === 9)) {
        if (index >= maxLength || index < 0) {
          elActive.removeClass("active");
          el.eq(0).addClass("active");
        } else {
          elActive.removeClass("active").next().addClass("active");
        }
      }

      // up or shift+tab
      if (e.which === 38 || (e.shiftKey && e.which === 9)) {
        if (index <= 0 || index < 0) {
          elActive.removeClass("active");
          el.eq(maxLength).addClass("active");
        } else {
          elActive.removeClass("active").prev().addClass("active");
        }
      }

      // space or enter
      if (e.which === 32 || e.which === 13) {
        elActive.find("label input").click();
      }
      if ($('.ms-drop:visible li:not(.ms-no-results).active').length) {
        var newActiveElTop = $('.ms-drop:visible li:not(.ms-no-results).active').position().top + $('.ms-drop:visible ul').scrollTop();
        if (newActiveElTop + 70 >= $('.ms-drop:visible  ul').outerHeight()) {
          $('.ms-drop:visible ul').scrollTop(newActiveElTop - $('.ms-drop:visible  ul').height() + 50);
        }
        if (newActiveElTop < $('.ms-drop:visible ul').scrollTop()) {
          $('.ms-drop:visible ul').scrollTop(newActiveElTop);
        }
      }
      e.preventDefault();
      return false;
    }

  }

  function multiSelectInit(selectMultiple, inputElement, single) {
    if (typeof inputElement === "undefined") inputElement = null;
    if (typeof single === "undefined") single = null;
    $(selectMultiple).multipleSelect({
      selectAll: false,
      single: single,
      // width: '100%',
      onClick: function () {
        if (inputElement) {
          window.setTimeout(function () {
            inputElement.click();
          }, 1500);
        }
        $('.ms-choice').removeClass("open");
        $('.overlayDropdown').fadeOut();
        setMSLabel();
        document.removeEventListener('keydown', multiSelectNavigation);
      },
      onClose: function () {
        if ($('.ms-drop:visible').length < 1) {
          $('.ms-choice').removeClass("open");
          $('.overlayDropdown').fadeOut();
          setMSLabel();
          document.removeEventListener('keydown', multiSelectNavigation);
        }
      },
      onOpen: function () {
        var select = $('select[data-drupal-selector=' + $(this)[0].drupalSelector + ']');
        select.next().find('.ms-choice').addClass('open');
        $('.overlayDropdown').fadeIn();
        document.addEventListener('keydown', multiSelectNavigation);
      }
    });
  }

  Drupal.behaviors.nettz = {
    attach: function (context, settings) {

      if ($('.node--type-akteuruebersicht').length > 0 && $('.view-id-search_api_akteure').length > 0) {
        var selectMultiple = $('.view-id-search_api_akteure select[multiple]');
        var inputElement = $("input[id*=edit-submit-akteure], input[id*=edit-submit-search-api-akteure]");
        multiSelectInit(selectMultiple, inputElement)
        $('.exposedResult:not(.Deutschland)').click(function () {
          var id = $(this).attr('id');
          selectMultiple.find('option[value=' + id + ']').removeAttr("selected");
          $("input[id*=edit-submit-akteure], input[id*=edit-submit-search-api-akteure]").click();
        });

        //--- exposed Filter Akteure overview show or hide Field Bundesländer ----
        var selectLand = $('select[data-drupal-selector=edit-field-land]');
        var exposedResultDL = $('.exposedResult.Deutschland');
        var selectBl = $('select[data-drupal-selector=edit-field-bundesland]');
        selectLand.change(function () {
          var valSelectLand = selectLand.val();
          if (valSelectLand && valSelectLand.indexOf('32') == 0) {
            $('.form-item-field-bundesland').css('display', 'block');
          } else {
            selectBl.multipleSelect("uncheckAll");
            $('.form-item-field-bundesland').fadeOut();
          }
        });
        exposedResultDL.click(function () {
          selectBl.multipleSelect("uncheckAll");
          var id = $(this).attr('id');
          selectLand.find('option[value=' + id + ']').removeAttr("selected");
          $("input[id*=edit-submit-akteure], input[id*=edit-submit-search-api-akteure]").click();
        });
        const inputSearchAkt = $('.view-search-api-akteure input');
        if (inputSearchAkt.length && inputSearchAkt.val().length) {
          inputSearchAkt.closest('.form-type-search-api-autocomplete').addClass('hasVal');
          inputSearchAkt.closest('.form-type-search-api-autocomplete').append('<div class="clearInput"></div>')
        }

        $('.clearInput').on('click touch', function () {
          inputSearchAkt.val('');
          $("input[id*=edit-submit-search-api-akteure]").click();
        });
        //--- ----

      } else if ($('.node--type-publikationsuebersicht').length > 0) {
        var selectMultiple = $('.view-id-search_api_publikationen select[multiple]');
        var inputElement = $("input[id*=edit-submit-publikationen], input[id*=edit-submit-search-api-publikationen]");
        multiSelectInit(selectMultiple, inputElement);

        $('.exposedResult').click(function () {
          var id = $(this).attr('id');
          selectMultiple.find('option[value=' + id + ']').removeAttr("selected");
          $("input[id*=edit-submit-publikationen], input[id*=edit-submit-search-api-publikationen]").click();
        });
        var inputSearchPub = $('.view-search-api-publikationen input');
        if (inputSearchPub.length && inputSearchPub.val().length) {
          inputSearchPub.closest('.form-type-search-api-autocomplete').addClass('hasVal');
          inputSearchPub.closest('.form-type-search-api-autocomplete').append('<div class="clearInput"></div>')
        }

        $('.clearInput').on('click touch', function () {
          inputSearchPub.val('');
          $("input[id*=edit-submit-search-api-publikationen]").click();
        })
      }
      // search page -----
      else if ($('.view-display-id-page_1').length > 0) {
        var selectMultiple = $('.view-display-id-page_1 select[multiple]');
        var inputElement = $("input[id*=edit-submit-search]");
        multiSelectInit(selectMultiple, inputElement)
        $('.exposedResult').click(function () {
          var id = $(this).attr('id');
          selectMultiple.find('option[value=' + id + ']').removeAttr("selected");
          $("input[id*=edit-submit-search]").click();
        });
      }

      var selectSingle = $('select[multiple].single, select.single');
      multiSelectInit(selectSingle, null, true);

      var selectMultiple = $('#main-wrapper select[multiple]:not(.single):not(.view-id-search_api_akteure_new select[multiple])');
      multiSelectInit(selectMultiple);

      //--- Vorschlagsformular selected Deutschland show Selectbox Bundesländer ----

      if ($('.webform-submission-vorschlagsformular-form').length > 0) {
        var select_land, select_land_val, select_bundesland;
        select_bundesland = $('.js-form-item-bundesland-auswaehlen');
        select_land = $('select[data-drupal-selector="edit-country"]');
        select_land.change(function () {
          select_land_val = select_land.val();
          if (select_land_val[0] && select_land_val[0] === 'DE') {
            select_bundesland.fadeIn();
          } else {
            select_bundesland.find($('select[data-drupal-selector=edit-bundesland-auswaehlen]')).multipleSelect("uncheckAll");
            select_bundesland.fadeOut();
          }
        });
      }
      //-----------

      setMSLabel();
    }
  };

  $(document).ready(function () {

    $(document).on("click touch", "a.disabled", function (e) {
      e.preventDefault();
      return false;
    });

    // focus stuff
    var mainContent = document.getElementById('main-content');
    var skipLink = document.getElementById('skip-link');
    skipLink.onclick = function (e) {
      e.preventDefault();
      mainContent.focus();
    }

    $(".menu-item--expanded li a").on("focus", function () {
      $(this).parents(".menu-item--expanded").addClass("open");
    }).focusout(function () {
      $(this).parents(".menu-item--expanded").removeClass("open");
    });

    $('.button-wrapper > a, .button-wrapper input.button').on("focus", function () {
      $(this).parents(".button-wrapper").addClass("active");
    }).focusout(function () {
      $(this).parents(".button-wrapper").removeClass("active");
    });

    $('.header.fixed a, .header.fixed li').attr("tabindex", "-1");
    // --- end: focus stuff

    //mobile menu opener
    $(document).on('click touch', ".menu-button", function () {
      $("body,#header,.menu-button").toggleClass("menu-is-open");
    });
    // ---

    if ($('.node--type-magazinuebersicht').length > 0) {
      var filter = $.getUrlVar('filter');
      if (typeof filter != "function") {
        $('select[id^="edit-field-rubrik-target-id"]').find('option[value=' + filter + ']').attr("selected", true);
        $("input[id*=edit-submit-magazin]").click();
      }
    }

    //header toggleDown desktop Stuff
    $(window).scroll(function () {
      var that = $(this);
      var windowWidth = that.outerWidth();
      if (windowWidth >= desktop) {
        if (that.scrollTop() > 150) {
          $('.header.fixed').addClass("open");
        } else {
          $('.header.fixed').removeClass("open");
        }
      }
    });
    // menu dropdown > overlayMenu
    if ($(window).outerWidth() >= desktop) {
      var menuItemExp = $('.region-primary-menu li.menu-item--expanded');
      menuItemExp.on('mouseover', function () {
        $('.overlayMenu').fadeIn(300);
      });
      menuItemExp.on('mouseleave', function () {
        $('.overlayMenu').fadeOut();
      });
    }
    if ($(window).outerWidth() < desktop) {
      var expList = $('.region-primary-menu li.menu-item--expanded');
      expList.on('click touch', function () {
        $('.region-primary-menu li.menu-item--expanded ul.menu').slideToggle();
        $(this).toggleClass('open');
      });
    }
    // ---

    $(document).on('submit', 'form.webform-submission-form', function (evt) {
      var valid = true;
      $(this).find('input[required="required"], textarea[required="required"]').each(function () {
        if ($(this).val() == "") {
          evt.preventDefault();
          $(this).addClass("error");
          valid = false;
          if ($(this).attr("type") == "checkbox") {
          }
        }
      });
      if (!valid) {
        $('html, body').animate({
          scrollTop: $('form.webform-submission-form').offset().top - 100 + 'px'
        }, 500, function () {
          $('html, body').stop();
        });
        return false;
      }
    });

    //header offset stuff
    if ($('.adminimal-admin-toolbar').length > 0) {
      setHeaderOffset();
      setTimeout(setHeaderOffset, 500);
      $(window).resize(function () {
        setHeaderOffset();
      });
      $(window).scroll(function () {
        setHeaderOffset();
      });
    }
    // ---

    // Detailseite Anchor-Scrolling
    $(document).on('click touch', "a[href^='#']", function () {
      var that = $(this);
      var idScroll = that.attr('href');
      var offset = 20;
      var bodyOffset = parseInt($('body').css('paddingTop'));
      var headerOffset = parseInt($('#header').outerHeight());
      var offsetTotal = offset + bodyOffset + headerOffset;
      $('html,body').animate({scrollTop: ($(idScroll).offset().top - offsetTotal)}, 'slow');
      return false;
    });
    // ---

    // Detailseite Anchor-Scrolling
    $(document).on('click touch', ".paragraph--type--frage", function () {
      var that = $(this);
      $(".paragraph--type--frage").removeClass('open');
      that.addClass("open");
      return false;
    });
    // ---

    $(document).on('click touch', ".search-link, .searchBlock .overlay", function () {
      var that = $(".search-link");
      that.toggleClass("open");
      $('.searchBlock').toggleClass("open");
      if ($('.searchBlock').hasClass("open")) {
        $('#views-exposed-form-search-page-2 input[name="keys"]').focus().select();
      }
      return false;
    });
    $(document).keydown(function (e) {
      if (e.key === "Escape") { // escape key maps to keycode `27`
        if ($('.searchBlock').hasClass("open")) {
          $('.searchBlock').removeClass("open");
          $(".search-link").removeClass("open");
        }
      }
      if ((e.ctrlKey || e.metaKey) && e.which === 75) {
        e.preventDefault();
        $('.searchBlock').addClass("open");
        $(".search-link").addClass("open");
        $('#views-exposed-form-search-page-2 input[name="keys"]').focus().select();
        return false;
      }
    });
    $(document).on('click touch', ".search-link", function () {
      $('.searchBlock select[multiple]').multipleSelect('checkAll');
      return false;
    });
    $('.searchBlock select[multiple]').multipleSelect({
      selectAll: false,
      allSelected: 'suche eingrenzen',
      countSelected: false,
      placeholder: 'suche eingrenzen',
      selectAllText: 'suche eingrenzen',
      displayValues: false
    });

    // Submenu fixed scroll
    if ($('.submenu').length > 0) {
      var submenu = $('.submenu');
      var detailMain = $('.detailMain');
      var pageWrapper = $('.page-wrapper');
      var submenuOffset = detailMain.offset().top - pageWrapper.offset().top;
      $(window).resize(function () {
        submenuOffset = detailMain.offset().top - pageWrapper.offset().top;
      });
      $(window).scroll(function () {
        var that = $(this);
        var windowWidth = that.outerWidth();
        if (windowWidth >= medium) {
          var offset = 20;
          var bodyOffset = parseInt($('body').css('paddingTop'));
          var headerOffset = parseInt($('#header').outerHeight());
          var offsetTotal = offset + bodyOffset + headerOffset;

          if (that.scrollTop() + offsetTotal + submenu.outerHeight() >= detailMain.offset().top + detailMain.outerHeight()) {
            submenu.removeClass('fixed');
            submenu.addClass('end');
            submenu.css('marginTop', 0);
          } else if (that.scrollTop() + offset + headerOffset > submenuOffset && that.scrollTop() + offset + headerOffset + submenu.outerHeight() < detailMain.offset().top + detailMain.outerHeight()) {
            submenu.addClass('fixed');
            submenu.removeClass('end');
            submenu.css('marginTop', offsetTotal + 'px');
          } else {
            submenu.removeClass('fixed');
            submenu.removeClass('end');
            submenu.css('marginTop', 0);
          }
        }
      });
    }
    // ---

  });

  function setMSLabel() {
    $('.ms-choice > span').text(function () {
      var labelText = $(this).parents('.form-item').find('> label').text();
      return labelText;
    });
  }

  // functions
  function setHeaderOffset() {
    var windowWidth = $(window).outerWidth();
    var header = $('#header');
    var headerFixed = $('.header.fixed');
    var menuContainer = $('#header .menuContainer');
    var bodyOffsetGlobal = parseInt($('body').css('paddingTop'));
    if (windowWidth < desktop) {
      header.css("top", bodyOffsetGlobal + "px");
      menuContainer.css("marginTop", bodyOffsetGlobal + "px");
    } else {
      header.css("top", 0);
      headerFixed.css("top", bodyOffsetGlobal + "px");
      menuContainer.css("marginTop", 0);
    }
    $('.searchBlock').css("marginTop", bodyOffsetGlobal + "px");
  }

  // ---

  // ------ set cookie for overlay Newsletter ------------
  var nl_overlay = $('.nl-overlay');
  var closeOl = $('.nl-overlay .icon-close');
  var link_nl = $('.nl-box');
  if ((readCookie("Overlay-Newsletter") != "noshow") && window.location.pathname != "/newsletter") {
    setTimeout(function () {
      nl_overlay.addClass('show');
    }, 1500)
  }
  closeOl.on('click touch', function () {
    nl_overlay.removeClass('show');
    createCookie("Overlay-Newsletter", "noshow", false);
  });
  link_nl.on('click touch', function () {
    nl_overlay.removeClass('show');
    createCookie("Overlay-Newsletter", "noshow", false);
  });
  // ------------

})(jQuery, Drupal);

function createCookie(name, value, days) {
  var expires = "";
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}
